/* eslint react/jsx-no-target-blank: 0 */
import * as React from 'react';
import { QRCode } from 'react-qr-svg';
import Text from '../../../shared/Text';
import classNames from 'classnames';

interface Props {
  onChangeTotp: () => void;
  submitForm: () => void;
  resetForm: () => void;
  totpKeyUri: string;
  totpSecret: string;
  isFormDisabled: boolean;
  isTotpInvalid: boolean;
}

interface State {
  isSecretVisible: boolean;
}

const LINK_GA_IOS_URL = 'https://itunes.apple.com/us/app/google-authenticator/id388497605';
const LINK_GA_ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2';
const LINK_AUTH_FIREFOX_URL =
  'https://addons.mozilla.org/en-US/firefox/addon/auth-helper/?src=external-website';
const LINK_AUTH_CHROME_URL =
  'https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai';
const LINK_AUTH_EDGE_URL =
  'https://microsoftedge.microsoft.com/addons/detail/authenticator/ocglkepbibnalbgmbachknglpdipeoio';

export default class LoginStepTotpConfig extends React.Component<Props, State> {
  constructor() {
    super();
    this.state = {
      isSecretVisible: true, // defaulting to show the secret
    };
  }

  submitForm = (e: React.FormEvent<any>) => {
    if (e && 'preventDefault' in e) {
      e.preventDefault();
    }
    if (typeof this.props.submitForm === 'function') {
      this.props.submitForm();
    }
  };

  resetForm = (e: React.MouseEvent<any>) => {
    if (e && 'preventDefault' in e) {
      e.preventDefault();
    }
    if (typeof this.props.resetForm === 'function') {
      this.props.resetForm();
    }
  };

  showSecret = (e: React.MouseEvent<any>) => {
    if (e && 'preventDefault' in e) {
      e.preventDefault();
    }
    this.setState({ isSecretVisible: true });
  };

  render() {
    const { onChangeTotp, isTotpInvalid, isFormDisabled, totpKeyUri, totpSecret } = this.props;

    const { isSecretVisible } = this.state;

    return (
      <form
        className="step-totp-config"
        data-test="login-form"
        name="loginFrm"
        noValidate
        onSubmit={this.submitForm}
      >
        <h1 className="totp-config-headline">{Text.get('login_totp_config_headline')}</h1>
        <p className="totp-config-description">{Text.get('login_totp_config_description')}</p>
        <ol className="totp-config-steps-list">
          <li>
            <h2 className="totp-config-headline">{Text.get('login_totp_config_step1_headline')}</h2>
            <p className="totp-config-step-body bordered">
              <span>{Text.get('login_totp_config_step1_app')}</span>
              <span className="inline-pad">&mdash;</span>
              <a target="_blank" className="primary" href={LINK_GA_IOS_URL}>
                {Text.get('login_totp_config_device_ios')}
              </a>
              <span className="inline-pad">&#124;</span>
              <a target="_blank" className="primary" href={LINK_GA_ANDROID_URL}>
                {Text.get('login_totp_config_device_android')}
              </a>
              <br />
              <span>{Text.get('login_totp_config_step1_browser')}</span>
              <span className="inline-pad">&mdash;</span>
              <br />
              <a target="_blank" className="primary" href={LINK_AUTH_FIREFOX_URL}>
                {Text.get('login_totp_config_browser_firefox')}
              </a>
              <span className="inline-pad">&#124;</span>
              <a target="_blank" className="primary" href={LINK_AUTH_CHROME_URL}>
                {Text.get('login_totp_config_browser_chrome')}
              </a>
              <span className="inline-pad">&#124;</span>
              <a target="_blank" className="primary" href={LINK_AUTH_EDGE_URL}>
                {Text.get('login_totp_config_browser_edge')}
              </a>
            </p>
          </li>
          <li>
            <h2 className="totp-config-headline">{Text.get('login_totp_config_step2_headline')}</h2>
            <p className="totp-config-step-body bordered">
              {!isSecretVisible && (
                <span>
                  <span>{Text.get('login_totp_config_step2_opt1_or')}</span>
                  <br />
                  <a href="#" className="primary" onClick={this.showSecret}>
                    {Text.get('login_totp_config_step2_opt2')}
                  </a>
                </span>
              )}
              {isSecretVisible && (
                <span>
                  <span>{Text.get('login_totp_config_step2_opt1_or_enter')}</span>
                  <textarea
                    autoFocus
                    className="totp-input totp-secret-input"
                    data-test="totp-secret"
                    id="totp-secret"
                    value={totpSecret || ''}
                  />
                </span>
              )}
              <QRCode level="L" value={totpKeyUri} className="totp-qr-code aafix" />
            </p>
          </li>
          <li>
            <h2 className="totp-config-headline">{Text.get('login_totp_config_step3_headline')}</h2>
            <div className="totp-config-step-body">
              <input
                autoFocus
                className={classNames('totp-input', { errored: isTotpInvalid })}
                data-test="totp-code"
                disabled={isFormDisabled}
                id="totp-code"
                maxLength={6}
                onChange={onChangeTotp}
              />
              <p className="totp-helper-text">{Text.get('login_totp_config_step3_description')}</p>
              {isTotpInvalid && (
                <p className="totp-verify-error totp-helper-text">
                  {Text.get('login_totp_config_step3_error')}
                </p>
              )}
            </div>
          </li>
        </ol>
        <div className="form-control-wrapper submit">
          <input
            type="submit"
            value={Text.get('login_button_sign_in')}
            className="btn btn-default btn-flat btn-customizable c42-orange c42-button"
            data-test="submit"
            disabled={isFormDisabled}
          />
        </div>
        <div className="form-control-wrapper link">
          <a href="#" onClick={this.resetForm} data-test="signin-different-account">
            {Text.get('sso_signin_different_account')}
          </a>
        </div>
      </form>
    );
  }
}
